import React from 'react';
import './App.scss';
import Contact from './components/Contact';
import Introduction from './components/Introduction';
import Landing from './components/Landing';

function App() {
  return (
    <div className="App">
      <Landing />
      <Introduction />
      <Contact />
    </div>
  );
}

export default App;
